import "./styles.css";
import React from "react";
import { Space, Typography, Menu, Modal, Popover, Avatar, Layout, message, FloatButton } from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  LockOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  WhatsAppOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { configModal } from "../modalConfig/config";
import { useState } from "react";
import { ContentLayout } from "../contentLayout";
import { IMAGES } from "../../constants/images";
import { useAuth } from "../../contexts/AuthContext";
import { handleLogout } from "../../api/autenticacao";

const { Text } = Typography;

const styles = {
  containerCadastro: {
    backgroundImage: `url(${IMAGES.backgroundHome})`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
  },
};

export const AuthLayout = ({ children }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const { session, encerrarSessao } = useAuth();

  const logout = async () => {
    const api = await handleLogout();
    if (api.statusCode === 200 || api.statusCode === 401) {
      await encerrarSessao();
      navigate("/login");
      message.success("Logout Realizado com sucesso!");
    } else {
      message.success(api.response.message);
    }
  };

  const items = [
    {
      label: "Alterar Senha",
      key: "1",
      icon: <LockOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        navigate("/alterar-senha");
        setOpen(!open);
      },
    },
    {
      label: "Consentimentos",
      key: "2",
      icon: <CheckCircleOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        navigate("/consentimentos");
        setOpen(!open);
      },
    },
    {
      label: "Excluir conta",
      key: "3",
      danger: true,
      icon: <DeleteOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        navigate("/excluir-conta");
        setOpen(!open);
      },
    },
    {
      label: "Sair",
      key: "4",
      icon: <LogoutOutlined style={{ fontSize: 16 }} />,
      onClick: () => {
        modal.confirm({
          ...configModal,
          title: "Deseja sair do sistema?",
          onOk() {
            logout();
          },
        });
      },
    },
  ];

  const handleHoverChange = () => {
    setOpen(false);
  };

  const content = <Menu selectedKeys={[]} style={{ border: "none" }} items={items} />;

  const HeaderPopover = () => {
    return (
      <Space size={20}>
        <Avatar size="large" shape="square" className="avatar-header" icon={<UserOutlined />} />
        <Text ellipsis style={{ width: 120 }}>
          {session?.usuario?.nome?.split(" ")[0]}
        </Text>
      </Space>
    );
  };

  return (
    <ContentLayout style={styles?.containerCadastro}>
      <Layout.Header className="page-header">
        <div>
          <Space size={20} className="header-content">
            <div className="logo-container">
              <img
                alt="copérdia"
                height={"100%"}
                width={"100%"}
                onClick={() => navigate("/")}
                src={IMAGES?.logoWhite}
              />
            </div>
            <Popover
              open={open}
              onOpenChange={handleHoverChange}
              content={content}
              onClick={() => setOpen(!open)}
              title={HeaderPopover}
              trigger="click">
              <Avatar className="avatar-header pointer" shape="square" icon={<UserOutlined />} size="large" />
            </Popover>
          </Space>
        </div>
      </Layout.Header>
      {children}
      {contextHolder}
      <FloatButton.Group trigger="click" style={{ right: 24 }} icon={<QuestionCircleOutlined />}>
        <FloatButton icon={<WhatsAppOutlined />} onClick={() => window.open("https://wa.me/message/WKIFUWDNKN2FG1")} />
      </FloatButton.Group>
    </ContentLayout>
  );
};
